// https://vuex.vuejs.org/en/actions.html

import router from '@/router'

export default {
  ResetResellerContext ({ dispatch, commit }) {
    commit('SetResellerContext', null)
    dispatch('ResetStore')
  },
  SetResellercontext ({ dispatch, commit }, resellerUid) {
    commit('SetResellerContext', resellerUid)
    dispatch('ResetStore')
  },
  async ResetStore ({ dispatch }) {
    await dispatch('ResetBasket')
    await dispatch('ResetCustomers')
    await dispatch('ResetOrders')
    await dispatch('ResetProducts')
    await dispatch('ResetSubscriptions')
    router.push({ name: 'Dashboard' })
  },
}
